export default "__VITE_PUBLIC_ASSET__eb29cd34__"